import React from 'react';
import Loader from 'Components/Forms/Loader';
import useMessages from 'hooks/useMessages';
import { useMutation, useQuery } from '@apollo/client';
import { GET_USER_DETAILS } from 'graphql/secure/queries';
import { UPDATE_USER } from 'graphql/secure/mutations';
import Container from 'FeatureModules/Setting/Components/Container';
import { ICompanyUser } from 'FeatureModules/Auth/types/companyUser.types';
import ErrorState from 'Components/ErrorState';
import SettingsHeader from '../Components/SettingsHeader';
import UserEditForm from '../Components/Forms/UserEditForm';

const UserDetails = () => {
  const { setSuccessMessage, setErrorMessage } = useMessages();

  const { data: { user } = {}, loading, error } = useQuery(GET_USER_DETAILS);

  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: () => {
      setSuccessMessage('Success! Your details were updated.');
    },
    onError: () => {
      setErrorMessage('Something went wrong updating your details.');
    },
    refetchQueries: ['GetUserDetails'],
  });

  const handleSubmit = async ({
    firstName,
    lastName,
    telephoneNumber,
    jobTitle,
    department,
  }: Partial<ICompanyUser>) => {
    await updateUser({
      variables: {
        input: {
          firstName,
          lastName,
          telephoneNumber,
          jobTitle,
          department,
        },
      },
    });
  };

  if (error) return <ErrorState />;
  if (!user && loading) return <Loader />;

  return (
    <Container>
      <SettingsHeader title="Profile" />
      <UserEditForm onSubmit={handleSubmit} user={user} />
    </Container>
  );
};

export default UserDetails;
